import gql from 'graphql-tag';

import referralFragment from '../fragments/referralFragment';

export const queryReferral = gql`
  query referral {
    referral {
      ...referralFragment
    }
  }
  ${referralFragment}
`;
export default queryReferral;
